"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the result of dividing the given double-double by 2.
 * @param q
 */
function qDivBy2([q, Q]) {
    return [q / 2, Q / 2];
}
exports.qDivBy2 = qDivBy2;
//# sourceMappingURL=q-div-by-2.js.map